import { SearchBlockNode, SearchParagraphNode } from "--client/../static_types/slate/Search"
import { UserBlock } from "--client/../static_types/slate/Shared"
import * as React from "react"
import styled, { useTheme } from "styled-components"
import { StyledMention } from "./common"
import IcoPhone from "@floji-internal/mui-icons/Phone"
import IcoEmail from "@floji-internal/mui-icons/Email"
import { RenderElementPropsT } from "../../utils"


export const MentionRendererSearch = (props: RenderElementPropsT<Exclude<SearchBlockNode, SearchParagraphNode | UserBlock>>) => {
    const theme = useTheme();
    const prefix = React.useMemo(() => {
        const parts = props.element.subType.split(":");
        parts.pop();
        return parts.join(":") + ":";
    }, [
        props.element.subType
    ]);
    return <StyledMention {...props.attributes} color={theme.palette.positive.main}>
        {
            props.element.subType === ":from:email" || props.element.subType === ":member:email"
                ? <StyledMentionLeadingIcon><IcoEmail size="14px" /></StyledMentionLeadingIcon>
                : props.element.subType === ":from:phone" || props.element.subType === ":member:phone"
                    ? <StyledMentionLeadingIcon><IcoPhone size="14px" /></StyledMentionLeadingIcon>
                    : null
        }
        {prefix}{props.element.children[0].text}
        {props.children}
    </StyledMention>
}

const StyledMentionLeadingIcon = styled.div`
	margin-right: ${props => props.theme.spacing(0.5)};
`